/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportInstallationsContent from "./ImportInstallationsContent";
import { ROUTE_COMPRESSORS_IMPORT } from "../../../../routes";

export default class extends Component {
  static propTypes = ImportInstallationsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          Para importar sus instalaciónes, los datos deben guardarse en formato ODS o TSV
          y seguir la siguiente estructura:
        </p>

        <ul>
          <li>Nº de cliente <i>(opcional) - Si una línea de instalación no tiene número de cliente, la instalación se creará para la cuenta de cliente a la que está asignado.</i></li>
          <li>Nº de centro</li>
          <li>Nº instalación</li>
          <li>
            Fluido
          </li>
          <li>
            Aceite <i>(opcional)</i>
          </li>
          <li>
            Fluido caloportador <i>(opcional)</i>
          </li>
          <li>Designación</li>
          <li>Carga nominal</li>
          <li>Carga actual</li>
          <li>
            Número de identificación <i>(opcional)</i>
          </li>
          <li>Marcador</li>
          <li>Fecha de puesta en servicio </li>
          <li>Fecha de la última verificación periódica</li>
          <li>
            Detector de fugas indirecto <i>(sin detector | 1 = presencia de un detector)</i>
          </li>
        </ul>
        <small>Campos obligatorios sólo cuando se añade un compresor a la instalación :</small>
        <ul>
          <li>Compresor: Marcador</li>
          <li>Compresor: Número de identificación <i>(opcional)</i></li>
          <li>Compresor: Nº de serie <i>(opcional)</i></li>
          <li>Compresor: Tipo</li>
          <li>Compresor: Clasificación</li>
          <li>Compresor: Marca <i>(opcional)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          Para importar varios compresores en la misma instalación, <a href={ROUTE_COMPRESSORS_IMPORT}>haga clic aquí</a>.
        </p>

        <p>
          Después de la integración, un resumen le informará sobre el número de
          entidades creadas o actualizadas, y le proporcionará un archivo de
          anomalía que contiene las líneas no integradas, y la(s) razón(es) del
          rechazo.
        </p>

        <p>Las posibles causas de las anomalías son:</p>

        <ul>
          <li>Ausencia de datos obligatorios</li>
          <li>El fluido, aceite o fluido caloportador no existe</li>
          <li>Valor del indicador diferente de 1/0</li>
          <li>Fecha no válida</li>
          <li>El tipo, clasificación o marca del compresor no existe</li>
        </ul>
      </div>
    );
  }
}
